import { GzIzIntegrationStatusWebComponent } from './component/GzIzIntegrationStatusWebComponent';

export { GzIzIntegrationStatusWebComponent };
